import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationRU from './locales/ru.json';
import translationHY from './locales/hy.json';

const resources = {
  en: { translation: translationEN },
  ru: { translation: translationRU },
  hy: { translation: translationHY },
};

const setDocumentLanguage = (language) => {
  document.documentElement.lang = language;
};

i18n.on('languageChanged', (language) => {
  setDocumentLanguage(i18n.resolvedLanguage || language);
});

i18n
  .use(LanguageDetector) // Подключаем автоматическое определение языка
  .use(initReactI18next) // Интегрируем с React
  .init({
    resources,
    fallbackLng: 'en', // Язык по умолчанию, если язык браузера не поддерживается
    debug: false, // Включите true для вывода логов в консоль при разработке
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'navigator'], // Порядок проверки источников языка
      caches: ['localStorage', 'cookie'], // Где сохранять выбранный язык
    },
    interpolation: {
      escapeValue: false, // Не нужно экранировать строки для React (он делает это сам)
    },
  })
  .then(() => {
    setDocumentLanguage(i18n.resolvedLanguage || i18n.language);
  });

export default i18n;
